const LevelsEnum = {
    STARTER: "STARTER",
    BEGINNER: "BEGINNER",
    INTERMEDIATE: "INTERMEDIATE",
    ADVANCED: "ADVANCED",
    MASTER: "MASTER",
    PRO: "PRO",
};

const ElementaryLevelsEnum = {
    STARTER: "STARTER",
    ADVANCED: "ADVANCED",
    MASTER: "MASTER",
    PRO: "PRO",
};

const HemedLevelsEnum = {
    BEGINNER: "BEGINNER",
    INTERMEDIATE: "INTERMEDIATE",
    ADVANCED: "ADVANCED",
    MASTER: "MASTER",
    PRO: "PRO",
};

const HemedElementaryLevelsEnum = {
    BEGINNER: "BEGINNER",
    ADVANCED: "ADVANCED",
    PRO: "PRO",
};

export { LevelsEnum, ElementaryLevelsEnum, HemedLevelsEnum, HemedElementaryLevelsEnum };